import * as React from 'react';
const SvgFullScreen = props => (
  <svg
    fill="currentColor"
    viewBox="0 0 18.467 18.433"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.692 1.883 6.683 0H0v6.683h1.908L1.75 3.092l4.05 4.05L7.142 5.8 3.075 1.733zM11.783 0v1.908l3.592-.158-4.05 4.05 1.342 1.342 4.066-4.075-.15 3.625 1.884-.009V0zM16.717 15.342l-4.05-4.05-1.342 1.341 4.067 4.067-3.617-.15.008 1.883h6.684V11.75h-1.909zM5.8 11.292l-4.067 4.075.15-3.625L0 11.75v6.683h6.683v-1.908l-3.591.158 4.05-4.05z" />
  </svg>
);
export default SvgFullScreen;
